import React, {
    useEffect,
    useState
} from "react";

import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import API_BASE_URL from "../config/config";

import "./ShowFreeResult.css";


function ReviewPrime() {

    const navigate =
        useNavigate();


    const {
        category,
        historyId
    } = useParams();


    const location =
        useLocation();


    /*
    |--------------------------------------------------------------------------
    | Sidebar
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | User Name
    |--------------------------------------------------------------------------
    */

    const name =
        Cookies.get("username") ||
        "Student";


    /*
    |--------------------------------------------------------------------------
    | Result State
    |--------------------------------------------------------------------------
    */

    const [
        result,
        setResult
    ] = useState(null);


    const [
        loading,
        setLoading
    ] = useState(true);


    const [
        error,
        setError
    ] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Paper
    |--------------------------------------------------------------------------
    */

    const [
        paper,
        setPaper
    ] = useState(
        location.state?.paper ||
        null
    );


    /*
    |--------------------------------------------------------------------------
    | First Attempt ID
    |--------------------------------------------------------------------------
    */

    const firstAttemptId =
        location.state?.firstAttemptId ||
        historyId ||
        null;


    /*
    |--------------------------------------------------------------------------
    | Category
    |--------------------------------------------------------------------------
    */

    const resultCategory =
        location.state?.category ||
        category ||
        "";


    /*
    |--------------------------------------------------------------------------
    | Fetch First Attempt Result
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        let cancelled = false;


        const fetchResult = async () => {

            if (!firstAttemptId) {

                if (!cancelled) {

                    setError(
                        "First attempt result ID is missing."
                    );

                    setLoading(false);

                }

                return;

            }


            try {

                if (!cancelled) {

                    setLoading(true);

                    setError("");

                }


                const apiBase =
                    String(
                        API_BASE_URL
                    ).replace(
                        /\/$/,
                        ""
                    );


                const response =
                    await fetch(
                        `${apiBase}/premium-paper/result/${encodeURIComponent(
                            firstAttemptId
                        )}`,
                        {
                            method: "GET",

                            credentials: "include",

                            headers: {
                                "Accept": "application/json"
                            }
                        }
                    );


                const data =
                    await response.json();


                console.log(
                    "PREMIUM PAPER RESULT API:",
                    data
                );


                if (!response.ok) {

                    throw new Error(
                        data?.message ||
                        "Unable to fetch result."
                    );

                }


                if (
                    data?.status === false
                ) {

                    throw new Error(
                        data?.message ||
                        "Result not found."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Normalize API Result
                |--------------------------------------------------------------------------
                */

                const resultData =
                    data?.data &&
                    typeof data.data === "object"

                        ? data.data

                        : data?.result &&
                          typeof data.result === "object"

                            ? data.result

                            : data;


                console.log(
                    "NORMALIZED PREMIUM PAPER RESULT:",
                    resultData
                );


                if (!cancelled) {

                    setResult(
                        resultData
                    );


                    if (
                        resultData?.paper &&
                        typeof resultData.paper === "object"
                    ) {

                        setPaper(
                            resultData.paper
                        );

                    }

                }

            } catch (err) {

                console.error(
                    "PREMIUM PAPER RESULT ERROR:",
                    err
                );


                if (!cancelled) {

                    setError(
                        err?.message ||
                        "Unable to load result."
                    );

                }

            } finally {

                if (!cancelled) {

                    setLoading(false);

                }

            }

        };


        fetchResult();


        return () => {

            cancelled = true;

        };


    }, [
        firstAttemptId
    ]);


    /*
    |--------------------------------------------------------------------------
    | Back To Premium Papers
    |--------------------------------------------------------------------------
    */

    const handleBackToPapers = () => {

        navigate(
            "/premium-paper-categories"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="dashboard-content py-4 px-3 px-md-4">

                        <div className="show-result-container">

                            <div className="result-empty-box">

                                <div className="result-empty-icon">

                                    <i className="bi bi-hourglass-split"></i>

                                </div>


                                <h3>
                                    Loading Result...
                                </h3>


                                <p>
                                    Please wait while we load your
                                    first attempt result.
                                </p>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Error
    |--------------------------------------------------------------------------
    */

    if (
        error ||
        !result ||
        !Array.isArray(result.review)
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="dashboard-content py-4 px-3 px-md-4">

                        <div className="show-result-container">

                            <div className="result-empty-box">

                                <div className="result-empty-icon">

                                    <i className="bi bi-file-earmark-x"></i>

                                </div>


                                <h3>
                                    Result Not Found
                                </h3>


                                <p>
                                    {
                                        error ||
                                        "Result information is not available."
                                    }
                                </p>


                                <button
                                    type="button"
                                    className="result-back-btn"
                                    onClick={
                                        handleBackToPapers
                                    }
                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Premium Papers

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | REVIEW
    |--------------------------------------------------------------------------
    */

    const review =
        Array.isArray(result.review)
            ? result.review
            : [];


    /*
    |--------------------------------------------------------------------------
    | TOTAL QUESTIONS
    |--------------------------------------------------------------------------
    */

    const totalQuestions =
        Number(
            result.total_questions ??
            review.length ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | CALCULATE STATISTICS
    |--------------------------------------------------------------------------
    */

    let calculatedAttempted = 0;

    let calculatedCorrect = 0;

    let calculatedWrong = 0;

    let calculatedUnanswered = 0;


    review.forEach(
        item => {

            const selectedOption =
                String(
                    item?.selected_option ??
                    "0"
                )
                    .trim()
                    .toUpperCase();


            const status =
                String(
                    item?.status ??
                    ""
                )
                    .trim()
                    .toLowerCase();


            const isUnanswered =
                selectedOption === "" ||
                selectedOption === "0" ||
                selectedOption === "NULL" ||
                status === "unanswered";


            const isCorrect =
                item?.is_correct === true ||
                item?.is_correct === 1 ||
                status === "correct";


            if (isUnanswered) {

                calculatedUnanswered++;

                return;

            }


            calculatedAttempted++;


            if (isCorrect) {

                calculatedCorrect++;

            } else {

                calculatedWrong++;

            }

        }
    );


    /*
    |--------------------------------------------------------------------------
    | FINAL STATISTICS
    |--------------------------------------------------------------------------
    */

    const attempted =
        calculatedAttempted;


    const correct =
        calculatedCorrect;


    const wrong =
        calculatedWrong;


    const unanswered =
        calculatedUnanswered;


    /*
    |--------------------------------------------------------------------------
    | MARKS
    |--------------------------------------------------------------------------
    */

    const marksPerQuestion =
        Number(
            result.marks ??
            result.paper?.marks ??
            paper?.marks ??
            1
        );


    const negativeMarks =
        Number(
            result.negative_marks ??
            result.paper?.negative_marks ??
            paper?.negative_marks ??
            0
        );


    const calculatedScore =
        (
            calculatedCorrect *
            marksPerQuestion
        ) -
        (
            calculatedWrong *
            negativeMarks
        );


    const score =
        result.score !== undefined &&
        result.score !== null &&
        result.score !== ""

            ? Number(
                result.score
            )

            : calculatedScore;


    /*
    |--------------------------------------------------------------------------
    | TOTAL MARKS
    |--------------------------------------------------------------------------
    */

    const totalMarks =
        result.total_marks !== undefined &&
        result.total_marks !== null &&
        result.total_marks !== ""

            ? Number(
                result.total_marks
            )

            : (
                Number(totalQuestions) *
                Number(marksPerQuestion)
            );


    /*
    |--------------------------------------------------------------------------
    | PERCENTAGE
    |--------------------------------------------------------------------------
    */

    const calculatedPercentage =
        totalMarks > 0

            ? (
                (
                    score /
                    totalMarks
                ) * 100
            )

            : 0;


    const percentage =
        result.percentage !== undefined &&
        result.percentage !== null &&
        result.percentage !== ""

            ? Math.max(
                0,
                Math.round(
                    Number(
                        result.percentage
                    )
                )
            )

            : Math.max(
                0,
                Math.round(
                    calculatedPercentage
                )
            );


    /*
    |--------------------------------------------------------------------------
    | ATTEMPT NUMBER
    |--------------------------------------------------------------------------
    */

    const reattempt =
        Number(
            result.reattempt ??
            0
        );


    const attemptNumber =
        Number(
            result.attempt_number ??
            (
                reattempt === 0
                    ? 1
                    : 2
            )
        );


    /*
    |--------------------------------------------------------------------------
    | DEBUG
    |--------------------------------------------------------------------------
    */

    console.log(
        "FINAL REVIEW PRIME STATISTICS:",
        {
            firstAttemptId,
            resultCategory,
            totalQuestions,
            marksPerQuestion,
            negativeMarks,
            totalMarks,
            attempted,
            correct,
            wrong,
            unanswered,
            score,
            percentage,
            attemptNumber,
            review
        }
    );


    /*
    |--------------------------------------------------------------------------
    | Practice Again
    |--------------------------------------------------------------------------
    */

    const handlePracticeAgain = () => {

        if (
            !paper?.paper_id
        ) {

            return;

        }


        navigate(
            `/premium-paper/start/${encodeURIComponent(
                paper.paper_id
            )}`,
            {
                replace: true
            }
        );

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION NUMBER / LETTER CONVERTER
    |--------------------------------------------------------------------------
    |
    | Backend:
    |
    | 1 = A
    | 2 = B
    | 3 = C
    | 4 = D
    |
    | Frontend me hamesha A/B/C/D use hoga.
    |--------------------------------------------------------------------------
    */

    const normalizeOption = (option) => {

        const value =
            String(
                option ?? ""
            )
                .trim()
                .toUpperCase();


        if (
            value === "A" ||
            value === "1"
        ) {

            return "A";

        }


        if (
            value === "B" ||
            value === "2"
        ) {

            return "B";

        }


        if (
            value === "C" ||
            value === "3"
        ) {

            return "C";

        }


        if (
            value === "D" ||
            value === "4"
        ) {

            return "D";

        }


        return "0";

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION TEXT
    |--------------------------------------------------------------------------
    */

    const getOptionText = (
        item,
        option
    ) => {

        const normalizedOption =
            normalizeOption(
                option
            );


        if (
            normalizedOption === "A"
        ) {

            return (
                item?.option1 ||
                ""
            );

        }


        if (
            normalizedOption === "B"
        ) {

            return (
                item?.option2 ||
                ""
            );

        }


        if (
            normalizedOption === "C"
        ) {

            return (
                item?.option3 ||
                ""
            );

        }


        if (
            normalizedOption === "D"
        ) {

            return (
                item?.option4 ||
                ""
            );

        }


        return "";

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION LETTER
    |--------------------------------------------------------------------------
    |
    | IMPORTANT:
    | Your Answer / Correct Answer me sirf A/B/C/D show hoga.
    |--------------------------------------------------------------------------
    */

    const getOptionLabel = (
        option
    ) => {

        const normalizedOption =
            normalizeOption(
                option
            );


        if (
            normalizedOption === "A"
        ) {

            return "A";

        }


        if (
            normalizedOption === "B"
        ) {

            return "B";

        }


        if (
            normalizedOption === "C"
        ) {

            return "C";

        }


        if (
            normalizedOption === "D"
        ) {

            return "D";

        }


        return "-";

    };


    /*
    |--------------------------------------------------------------------------
    | Render
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            <main className="dashboard-main">

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <div className="dashboard-content py-4 px-3 px-md-4">

                    <div className="show-result-container">


                        {/* =====================================================
                            RESULT HEADER
                        ===================================================== */}

                        <div className="result-header-card">

                            <div className="result-header-content">

                                <span className="result-small-title">

                                    PREMIUM PAPER RESULT

                                </span>


                                <h1>

                                    {
                                        paper?.paper ||
                                        (
                                            typeof result.paper === "object"
                                                ? result.paper?.paper
                                                : result.paper
                                        ) ||
                                        `Paper #${
                                            paper?.paper_id ||
                                            result.paper_id ||
                                            firstAttemptId
                                        }`
                                    }

                                </h1>


                                <p>

                                    Attempt{" "}

                                    {attemptNumber}

                                </p>

                            </div>


                            <div className="result-score-circle">

                                <strong>
                                    {percentage}%
                                </strong>


                                <span>
                                    Score
                                </span>

                            </div>

                        </div>


                        {/* =====================================================
                            SUMMARY
                        ===================================================== */}

                        <div className="result-summary-grid">


                            <div className="result-summary-card summary-total">

                                <div className="result-summary-icon">

                                    <i className="bi bi-list-check"></i>

                                </div>


                                <div>

                                    <span>
                                        Total Questions
                                    </span>


                                    <strong>
                                        {totalQuestions}
                                    </strong>

                                </div>

                            </div>


                            <div className="result-summary-card summary-correct">

                                <div className="result-summary-icon">

                                    <i className="bi bi-check-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Correct
                                    </span>


                                    <strong>
                                        {correct}
                                    </strong>

                                </div>

                            </div>


                            <div className="result-summary-card summary-wrong">

                                <div className="result-summary-icon">

                                    <i className="bi bi-x-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Wrong
                                    </span>


                                    <strong>
                                        {wrong}
                                    </strong>

                                </div>

                            </div>


                            <div className="result-summary-card summary-unanswered">

                                <div className="result-summary-icon">

                                    <i className="bi bi-dash-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Unanswered
                                    </span>


                                    <strong>
                                        {unanswered}
                                    </strong>

                                </div>

                            </div>


                            <div className="result-summary-card summary-attempted">

                                <div className="result-summary-icon">

                                    <i className="bi bi-pencil-square"></i>

                                </div>


                                <div>

                                    <span>
                                        Attempted
                                    </span>


                                    <strong>
                                        {attempted}
                                    </strong>

                                </div>

                            </div>


                            <div className="result-summary-card summary-score">

                                <div className="result-summary-icon">

                                    <i className="bi bi-award"></i>

                                </div>


                                <div>

                                    <span>
                                        Score
                                    </span>


                                    <strong>

                                        {score}
                                        /
                                        {totalMarks}

                                    </strong>

                                </div>

                            </div>

                        </div>


                        {/* =====================================================
                            QUESTION REVIEW
                        ===================================================== */}

                        <div className="question-review-section">

                            <div className="question-review-heading">

                                <div>

                                    <span>
                                        QUESTION REVIEW
                                    </span>


                                    <h2>
                                        Review Your Answers
                                    </h2>

                                </div>


                                <div className="review-count">

                                    {review.length}
                                    {" "}
                                    Questions

                                </div>

                            </div>


                            {review.map(
                                (
                                    item,
                                    index
                                ) => {

                                    /*
                                    |--------------------------------------------------------------------------
                                    | Selected Option
                                    |--------------------------------------------------------------------------
                                    |
                                    | IMPORTANT:
                                    | 1/2/3/4 ko A/B/C/D me convert kiya ja raha hai.
                                    |--------------------------------------------------------------------------
                                    */

                                    const selectedOption =
                                        normalizeOption(
                                            item?.selected_option
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct Option
                                    |--------------------------------------------------------------------------
                                    */

                                    const correctOption =
                                        normalizeOption(
                                            item?.correct_option
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Status
                                    |--------------------------------------------------------------------------
                                    */

                                    const status =
                                        String(
                                            item?.status ??
                                            ""
                                        )
                                            .trim()
                                            .toLowerCase();


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct
                                    |--------------------------------------------------------------------------
                                    */

                                    const isCorrect =
                                        item?.is_correct === true ||
                                        item?.is_correct === 1 ||
                                        item?.is_correct === "1" ||
                                        status === "correct";


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Unanswered
                                    |--------------------------------------------------------------------------
                                    */

                                    const isUnanswered =
                                        selectedOption === "0" ||
                                        status === "unanswered";


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Selected Text
                                    |--------------------------------------------------------------------------
                                    */

                                    const selectedText =
                                        getOptionText(
                                            item,
                                            selectedOption
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct Text
                                    |--------------------------------------------------------------------------
                                    */

                                    const correctText =
                                        getOptionText(
                                            item,
                                            correctOption
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Final Status
                                    |--------------------------------------------------------------------------
                                    */

                                    const finalStatus =
                                        isUnanswered

                                            ? "unanswered"

                                            : isCorrect

                                                ? "correct"

                                                : "wrong";


                                    return (

                                        <div
                                            key={
                                                item?.question_id ||
                                                index
                                            }
                                            className={
                                                `result-question-card ${
                                                    finalStatus
                                                }`
                                            }
                                        >


                                            {/* =====================================
                                                QUESTION TOP
                                            ===================================== */}

                                            <div className="result-question-top">

                                                <div className="result-question-number">

                                                    Q{" "}

                                                    {String(
                                                        index + 1
                                                    ).padStart(
                                                        2,
                                                        "0"
                                                    )}

                                                </div>


                                                <div
                                                    className={
                                                        `question-status-badge ${
                                                            finalStatus
                                                        }`
                                                    }
                                                >

                                                    {finalStatus ===
                                                        "correct" && (

                                                        <>

                                                            <i className="bi bi-check-circle-fill"></i>

                                                            Correct

                                                        </>

                                                    )}


                                                    {finalStatus ===
                                                        "wrong" && (

                                                        <>

                                                            <i className="bi bi-x-circle-fill"></i>

                                                            Wrong

                                                        </>

                                                    )}


                                                    {finalStatus ===
                                                        "unanswered" && (

                                                        <>

                                                            <i className="bi bi-dash-circle-fill"></i>

                                                            Unanswered

                                                        </>

                                                    )}

                                                </div>

                                            </div>


                                            {/* =====================================
                                                QUESTION
                                            ===================================== */}

                                            <div
                                                className="result-question-text"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item?.question ||
                                                        ""
                                                }}
                                            />


                                            {/* =====================================
                                                OPTIONS
                                            ===================================== */}

                                            <div className="result-options">

                                                {[
                                                    "A",
                                                    "B",
                                                    "C",
                                                    "D"
                                                ].map(
                                                    option => {

                                                        const optionText =
                                                            getOptionText(
                                                                item,
                                                                option
                                                            );


                                                        const isSelected =
                                                            selectedOption ===
                                                            option;


                                                        const isCorrectOption =
                                                            correctOption ===
                                                            option;


                                                        let optionClass =
                                                            "result-option";


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Correct Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-correct";

                                                        }


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Wrong Selected Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isSelected &&
                                                            !isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-wrong";

                                                        }


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Selected Correct Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isSelected &&
                                                            isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-selected-correct";

                                                        }


                                                        return (

                                                            <div
                                                                key={
                                                                    option
                                                                }
                                                                className={
                                                                    optionClass
                                                                }
                                                            >

                                                                <div className="result-option-letter">

                                                                    {option}

                                                                </div>


                                                                <div
                                                                    className="result-option-text"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            optionText
                                                                    }}
                                                                />


                                                                <div className="result-option-status">

                                                                    {isCorrectOption && (

                                                                        <span className="correct-label">

                                                                            <i className="bi bi-check-circle-fill"></i>

                                                                            Correct Answer

                                                                        </span>

                                                                    )}


                                                                    {isSelected &&
                                                                        !isCorrectOption && (

                                                                            <span className="wrong-label">

                                                                                <i className="bi bi-x-circle-fill"></i>

                                                                                Your Answer

                                                                            </span>

                                                                        )}

                                                                </div>

                                                            </div>

                                                        );

                                                    }
                                                )}

                                            </div>


                                            {/* =====================================
                                                ANSWER INFORMATION
                                            ===================================== */}

                                            <div className="answer-information">


                                                <div className="answer-info-item">

                                                    <span>
                                                        Your Answer
                                                    </span>


                                                    <strong
                                                        className={
                                                            isUnanswered

                                                                ? "unanswered-text"

                                                                : isCorrect

                                                                    ? "correct-text"

                                                                    : "wrong-text"
                                                        }
                                                    >

                                                        {isUnanswered

                                                            ? "Not Answered"

                                                            : (
                                                                <>
                                                                    {getOptionLabel(
                                                                        selectedOption
                                                                    )}

                                                                    {
                                                                        selectedText
                                                                            ? ` - ${selectedText}`
                                                                            : ""
                                                                    }
                                                                </>
                                                            )

                                                        }

                                                    </strong>

                                                </div>


                                                <div className="answer-info-item">

                                                    <span>
                                                        Correct Answer
                                                    </span>


                                                    <strong className="correct-text">

                                                        {
                                                            correctOption !== "0"

                                                                ? getOptionLabel(
                                                                    correctOption
                                                                )

                                                                : "Not Available"
                                                        }


                                                        {
                                                            correctOption !== "0" &&
                                                            correctText
                                                                ? ` - ${correctText}`
                                                                : ""
                                                        }

                                                    </strong>

                                                </div>

                                            </div>


                                            {/* =====================================
                                                EXPLANATION
                                            ===================================== */}

                                            <div className="result-explanation">

                                                <div className="result-explanation-title">

                                                    <i className="bi bi-lightbulb-fill"></i>

                                                    Explanation

                                                </div>


                                                <div
                                                    className="result-explanation-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item?.explanation ||
                                                            "<p>Explanation not available.</p>"
                                                    }}
                                                />

                                            </div>


                                        </div>

                                    );

                                }
                            )}

                        </div>


                        {/* =====================================================
                            FOOTER BUTTONS
                        ===================================================== */}

                        <div className="result-action-buttons">


                            {attemptNumber < 2 && (

                                <button
                                    type="button"
                                    className="result-practice-btn"
                                    onClick={
                                        handlePracticeAgain
                                    }
                                >

                                    <i className="bi bi-arrow-repeat"></i>

                                    Practice Again

                                </button>

                            )}


                            <button
                                type="button"
                                className="result-back-btn"
                                onClick={
                                    handleBackToPapers
                                }
                            >

                                <i className="bi bi-arrow-left"></i>

                                Back to Premium Papers

                            </button>

                        </div>


                    </div>

                </div>

            </main>

        </div>

    );

}


export default ReviewPrime;